export const SSA_SALES_ANALYTICS = 'ssa_sales_analytics';
export const DANA_GOLDEN_MINUTE_DEBUG_TOOLS = 'dana_golden_minute_debug_tools';
export const FORCEBI = 'forcebi';
export const CROSS_FILTERS = 'cross_filters';
export const AUTOMATED_MARKETING_CAMPAIGNS = 'automated_marketing_campaigns';
export const AUTOMATIONS_SETTINGS = 'automations_settings';
export const BLOCK_MARKETING_CAMPAIGNS = 'block_marketing_campaigns';
export const COPILOT_SIDEBAR = 'copilot_sidebar';
export const MULTIENVIRONMENT_ENTITIES2 = 'multienvironment_entities2';
export const SAGE_STATUS_WIDGET = 'sage_status_widget';
export const COPILOT_BAR = 'copilot_bar';
export const COPILOT_BAR_LIVE = 'copilot_bar_live';
export const LEADS = 'leads';
export const SPAMCHIMP = 'spamchimp';
export const MARKETING_CAMPAIGN_LISTS = 'marketing_campaign_lists';

/** Known Flagsmith flags mirrored into `config.flagsmith` / Redux. */
export const FLAGSMITH_FLAGS_TO_CONFIG = [
    SSA_SALES_ANALYTICS,
    AUTOMATIONS_SETTINGS,
    AUTOMATED_MARKETING_CAMPAIGNS,
    BLOCK_MARKETING_CAMPAIGNS,
    COPILOT_BAR,
    COPILOT_BAR_LIVE,
    COPILOT_SIDEBAR,
    CROSS_FILTERS,
    DANA_GOLDEN_MINUTE_DEBUG_TOOLS,
    FORCEBI,
    LEADS,
    MARKETING_CAMPAIGN_LISTS,
    MULTIENVIRONMENT_ENTITIES2,
    SAGE_STATUS_WIDGET,
    SPAMCHIMP,
];
